import { render, staticRenderFns } from "./VerifyDocumentUpload.vue?vue&type=template&id=771e6213&scoped=true&"
import script from "./VerifyDocumentUpload.vue?vue&type=script&lang=ts&"
export * from "./VerifyDocumentUpload.vue?vue&type=script&lang=ts&"
import style0 from "./VerifyDocumentUpload.vue?vue&type=style&index=0&id=771e6213&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "771e6213",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VLayout,VProgressCircular,VRow})
